import { useState } from "react";
import OPIWidget from "./OPIWidget";

const css = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');
  .im-root { font-family: 'Inter', system-ui, -apple-system, sans-serif; }
  .im-root * { box-sizing: border-box; margin: 0; padding: 0; border: none; background: none; cursor: default; }
  .im-root button { cursor: pointer; -webkit-tap-highlight-color: transparent; }
  @keyframes imFadeIn { from { opacity:0; } to { opacity:1; } }
  @keyframes imSlideUp { from { opacity:0; transform:translateY(12px); } to { opacity:1; transform:translateY(0); } }
  @keyframes imPulse { 0%,100% { box-shadow: 0 0 0 0 rgba(99,102,241,0.4); } 50% { box-shadow: 0 0 0 10px rgba(99,102,241,0); } }
  .im-card { transition: all 0.2s ease; }
  .im-card:hover { transform: translateY(-2px); box-shadow: 0 12px 32px rgba(0,0,0,0.08); }
  .im-card:active { transform: translateY(0); }
  .im-lang-btn { transition: all 0.15s; }
  .im-lang-btn:active { transform: scale(0.96); }
`;

const LANGUAGES = [
  { code: "en",    name: "English",    flag: "\u{1F1FA}\u{1F1F8}" },
  { code: "es",    name: "Spanish",    flag: "\u{1F1EA}\u{1F1F8}" },
  { code: "fr",    name: "French",     flag: "\u{1F1EB}\u{1F1F7}" },
  { code: "de",    name: "German",     flag: "\u{1F1E9}\u{1F1EA}" },
  { code: "pt-BR", name: "Portuguese", flag: "\u{1F1E7}\u{1F1F7}" },
  { code: "it",    name: "Italian",    flag: "\u{1F1EE}\u{1F1F9}" },
  { code: "zh",    name: "Chinese",    flag: "\u{1F1E8}\u{1F1F3}" },
  { code: "ja",    name: "Japanese",   flag: "\u{1F1EF}\u{1F1F5}" },
  { code: "ko",    name: "Korean",     flag: "\u{1F1F0}\u{1F1F7}" },
  { code: "ar",    name: "Arabic",     flag: "\u{1F1F8}\u{1F1E6}" },
  { code: "hi",    name: "Hindi",      flag: "\u{1F1EE}\u{1F1F3}" },
  { code: "ru",    name: "Russian",    flag: "\u{1F1F7}\u{1F1FA}" },
  { code: "nl",    name: "Dutch",      flag: "\u{1F1F3}\u{1F1F1}" },
  { code: "pl",    name: "Polish",     flag: "\u{1F1F5}\u{1F1F1}" },
  { code: "tr",    name: "Turkish",    flag: "\u{1F1F9}\u{1F1F7}" },
  { code: "vi",    name: "Vietnamese", flag: "\u{1F1FB}\u{1F1F3}" },
  { code: "uk",    name: "Ukrainian",  flag: "\u{1F1FA}\u{1F1E6}" },
  { code: "tl",    name: "Filipino",   flag: "\u{1F1F5}\u{1F1ED}" },
  { code: "asl",   name: "ASL",        flag: "\u{1F91F}" },  // sign language
];

// Icons
const IconPhone = ({ size = 22, color = "#fff" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0 1 22 16.92Z"/>
  </svg>
);
const IconVideo = ({ size = 22, color = "#fff" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m22 8-6 4 6 4V8Z"/><rect width="14" height="12" x="2" y="6" rx="2" ry="2"/>
  </svg>
);
const IconGlobe = ({ size = 18, color = "#6366F1" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/><path d="M2 12h20"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
  </svg>
);
const IconSparkles = ({ size = 16, color = "#8B5CF6" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m12 3-1.9 5.8a2 2 0 0 1-1.3 1.3L3 12l5.8 1.9a2 2 0 0 1 1.3 1.3L12 21l1.9-5.8a2 2 0 0 1 1.3-1.3L21 12l-5.8-1.9a2 2 0 0 1-1.3-1.3Z"/><path d="M5 3v4"/><path d="M19 17v4"/><path d="M3 5h4"/><path d="M17 19h4"/>
  </svg>
);
const IconArrow = ({ size = 14, color = "#6366F1" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>
  </svg>
);
const IconClose = ({ size = 18, color = "#6B7280" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
  </svg>
);
const IconBack = ({ size = 18, color = "#6B7280" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="m15 18-6-6 6-6"/>
  </svg>
);

export default function InterpreterModal({ open, onClose }) {
  // Flow: service → languages → connecting / ai_session
  const [step, setStep] = useState("service");
  const [service, setService] = useState(null); // "opi" | "vri" | "ai"
  const [langA, setLangA] = useState(LANGUAGES[0]); // English default
  const [langB, setLangB] = useState(LANGUAGES[1]); // Spanish default
  const [picking, setPicking] = useState(null);

  if (!open) return null;

  const reset = () => {
    setStep("service"); setService(null); setPicking(null);
    setLangA(LANGUAGES[0]); setLangB(LANGUAGES[1]);
  };
  const close = () => { reset(); onClose?.(); };

  const handleServiceSelect = (svc) => {
    setService(svc);
    setStep("languages");
  };

  const handleConnect = () => {
    if (service === "ai") {
      setStep("ai_session");
    } else {
      setStep("coming_soon");
    }
  };

  // ─── AI Session (launches widget directly in modal) ───
  if (step === "ai_session") {
    return (
      <div className="im-root" style={{position:"fixed",inset:0,zIndex:9999,background:"rgba(15,16,30,0.6)",backdropFilter:"blur(12px)",display:"flex",alignItems:"center",justifyContent:"center",padding:16,animation:"imFadeIn 0.2s ease"}}>
        <style>{css}</style>
        <div style={{width:"100%",maxWidth:440,height:"min(720px, 92vh)",background:"#fff",borderRadius:24,overflow:"hidden",boxShadow:"0 24px 64px rgba(0,0,0,0.35)",animation:"imSlideUp 0.3s ease",display:"flex",flexDirection:"column"}}>
          <div style={{flex:1,overflow:"hidden"}}>
            <OPIWidget embedded onClose={close} initialLangA={langA} initialLangB={langB}/>
          </div>
        </div>
      </div>
    );
  }

  // ─── Language Picker Sub-screen ───
  if (picking) {
    const current = picking === "a" ? langA : langB;
    const other = picking === "a" ? langB : langA;
    return (
      <div className="im-root" style={{position:"fixed",inset:0,zIndex:9999,background:"rgba(15,16,30,0.6)",backdropFilter:"blur(12px)",display:"flex",alignItems:"center",justifyContent:"center",padding:16,animation:"imFadeIn 0.2s ease"}}>
        <style>{css}</style>
        <div style={{width:"100%",maxWidth:480,maxHeight:"88vh",background:"#fff",borderRadius:24,overflow:"hidden",boxShadow:"0 24px 64px rgba(0,0,0,0.35)",animation:"imSlideUp 0.3s ease",display:"flex",flexDirection:"column"}}>
          <div style={{padding:"20px 24px",display:"flex",alignItems:"center",justifyContent:"space-between",borderBottom:"1px solid #F3F4F6"}}>
            <button onClick={()=>setPicking(null)} style={{display:"flex",alignItems:"center",gap:4,fontSize:14,fontWeight:600,color:"#6B7280",padding:"6px 10px 6px 4px",borderRadius:8}}>
              <IconBack/> Back
            </button>
            <span style={{fontSize:16,fontWeight:700,color:"#1a1a2e",letterSpacing:"-0.02em"}}>Select language</span>
            <button onClick={close} style={{width:32,height:32,borderRadius:10,background:"#F3F4F6",display:"flex",alignItems:"center",justifyContent:"center"}}>
              <IconClose/>
            </button>
          </div>
          <div style={{flex:1,overflowY:"auto",padding:"16px",display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,alignContent:"start"}}>
            {LANGUAGES.filter(l => l.code !== other.code).map(lang => {
              const sel = current.code === lang.code;
              return (
                <button key={lang.code} className="im-lang-btn" onClick={()=>{
                  if (picking === "a") setLangA(lang); else setLangB(lang);
                  setPicking(null);
                }} style={{padding:"16px 8px",borderRadius:16,display:"flex",flexDirection:"column",alignItems:"center",gap:8,
                  background:sel?"#EEF2FF":"#fff",
                  border:sel?"2px solid #6366F1":"1.5px solid #E5E7EB",
                  boxShadow:sel?"0 0 0 3px rgba(99,102,241,0.1)":"0 1px 3px rgba(0,0,0,0.04)"}}>
                  <span style={{fontSize:28,lineHeight:1}}>{lang.flag}</span>
                  <span style={{fontSize:12,fontWeight:600,color:sel?"#4338CA":"#4B5563"}}>{lang.name}</span>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    );
  }

  // ─── Coming Soon (Human OPI/VRI placeholder) ───
  if (step === "coming_soon") {
    const serviceName = service === "opi" ? "Phone Interpretation" : "Video Interpretation";
    return (
      <div className="im-root" style={{position:"fixed",inset:0,zIndex:9999,background:"rgba(15,16,30,0.6)",backdropFilter:"blur(12px)",display:"flex",alignItems:"center",justifyContent:"center",padding:16,animation:"imFadeIn 0.2s ease"}}>
        <style>{css}</style>
        <div style={{width:"100%",maxWidth:440,background:"#fff",borderRadius:24,overflow:"hidden",boxShadow:"0 24px 64px rgba(0,0,0,0.35)",animation:"imSlideUp 0.3s ease"}}>
          <div style={{padding:"20px 24px",display:"flex",alignItems:"center",justifyContent:"space-between",borderBottom:"1px solid #F3F4F6"}}>
            <button onClick={()=>setStep("languages")} style={{display:"flex",alignItems:"center",gap:4,fontSize:14,fontWeight:600,color:"#6B7280",padding:"6px 10px 6px 4px",borderRadius:8}}>
              <IconBack/> Back
            </button>
            <button onClick={close} style={{width:32,height:32,borderRadius:10,background:"#F3F4F6",display:"flex",alignItems:"center",justifyContent:"center"}}>
              <IconClose/>
            </button>
          </div>

          <div style={{padding:"40px 32px",display:"flex",flexDirection:"column",alignItems:"center",gap:20,textAlign:"center"}}>
            <div style={{width:72,height:72,borderRadius:22,background:"linear-gradient(135deg,#F59E0B,#EF4444)",display:"flex",alignItems:"center",justifyContent:"center",boxShadow:"0 8px 32px rgba(239,68,68,0.2)"}}>
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
              </svg>
            </div>

            <div>
              <div style={{fontSize:22,fontWeight:800,color:"#1a1a2e",letterSpacing:"-0.02em",marginBottom:8}}>Coming Soon</div>
              <div style={{fontSize:14,color:"#6B7280",lineHeight:1.6,maxWidth:320}}>
                {serviceName} with certified human interpreters is launching soon.
              </div>
            </div>

            <div style={{background:"#F9FAFB",borderRadius:14,padding:"14px 16px",width:"100%",display:"flex",alignItems:"center",justifyContent:"center",gap:10,fontSize:13,color:"#4B5563",fontWeight:500}}>
              <span style={{fontSize:18}}>{langA.flag}</span>
              <span>{langA.name}</span>
              <IconArrow color="#9CA3AF"/>
              <span style={{fontSize:18}}>{langB.flag}</span>
              <span>{langB.name}</span>
            </div>

            {/* Offer AI as alternative */}
            <div style={{width:"100%",padding:"14px 16px",borderRadius:14,background:"linear-gradient(135deg,#EEF2FF,#F5F3FF)",border:"1px solid #DDD6FE",display:"flex",alignItems:"center",gap:12}}>
              <div style={{width:36,height:36,borderRadius:12,background:"linear-gradient(135deg,#6366F1,#8B5CF6)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                <IconSparkles color="#fff"/>
              </div>
              <div style={{flex:1,textAlign:"left"}}>
                <div style={{fontSize:13,fontWeight:700,color:"#4338CA"}}>Try AI Interpreter</div>
                <div style={{fontSize:11,color:"#6D28D9",opacity:0.8}}>Available right now</div>
              </div>
              <button onClick={()=>{setService("ai");setStep("ai_session");}} style={{padding:"8px 14px",borderRadius:10,background:"#fff",border:"1px solid #DDD6FE",fontSize:12,fontWeight:700,color:"#4338CA"}}>
                Start
              </button>
            </div>

            <button onClick={close} style={{fontSize:14,fontWeight:600,color:"#9CA3AF",marginTop:4,padding:"8px 16px"}}>
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }

  // ─── Step 2: Language Selection ───
  if (step === "languages") {
    const serviceLabel = service === "opi" ? "Phone Interpretation"
                       : service === "vri" ? "Video Interpretation"
                       : "AI Interpreter";
    const serviceColor = service === "ai" ? "#6366F1" : "#1a1a2e";

    return (
      <div className="im-root" style={{position:"fixed",inset:0,zIndex:9999,background:"rgba(15,16,30,0.6)",backdropFilter:"blur(12px)",display:"flex",alignItems:"center",justifyContent:"center",padding:16,animation:"imFadeIn 0.2s ease"}}>
        <style>{css}</style>
        <div style={{width:"100%",maxWidth:440,background:"#fff",borderRadius:24,overflow:"hidden",boxShadow:"0 24px 64px rgba(0,0,0,0.35)",animation:"imSlideUp 0.3s ease"}}>
          <div style={{padding:"20px 24px",display:"flex",alignItems:"center",justifyContent:"space-between",borderBottom:"1px solid #F3F4F6"}}>
            <button onClick={()=>setStep("service")} style={{display:"flex",alignItems:"center",gap:4,fontSize:14,fontWeight:600,color:"#6B7280",padding:"6px 10px 6px 4px",borderRadius:8}}>
              <IconBack/> Back
            </button>
            <button onClick={close} style={{width:32,height:32,borderRadius:10,background:"#F3F4F6",display:"flex",alignItems:"center",justifyContent:"center"}}>
              <IconClose/>
            </button>
          </div>

          <div style={{padding:"24px 28px 28px"}}>
            <div style={{fontSize:12,fontWeight:700,color:serviceColor,letterSpacing:"0.08em",textTransform:"uppercase",marginBottom:6}}>
              {serviceLabel}
            </div>
            <div style={{fontSize:22,fontWeight:800,color:"#1a1a2e",letterSpacing:"-0.02em",marginBottom:6}}>
              Choose languages
            </div>
            <div style={{fontSize:14,color:"#6B7280",marginBottom:24}}>
              Select the two languages you need to interpret between.
            </div>

            <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:24}}>
              <button onClick={()=>setPicking("a")}
                style={{flex:1,padding:"18px 14px",borderRadius:18,background:"#fff",border:"1.5px solid #E5E7EB",display:"flex",flexDirection:"column",alignItems:"center",gap:6,boxShadow:"0 1px 3px rgba(0,0,0,0.04)",transition:"all 0.15s"}}>
                <span style={{fontSize:32,lineHeight:1}}>{langA.flag}</span>
                <span style={{fontSize:14,fontWeight:700,color:"#1a1a2e"}}>{langA.name}</span>
                <span style={{fontSize:10,color:"#9CA3AF",fontWeight:600,letterSpacing:"0.04em"}}>CHANGE</span>
              </button>

              <button onClick={()=>{setLangA(langB);setLangB(langA);}}
                style={{width:40,height:40,borderRadius:20,background:"#F3F4F6",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6B7280" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M7 16l-4-4 4-4"/><path d="M17 8l4 4-4 4"/><path d="M3 12h18"/>
                </svg>
              </button>

              <button onClick={()=>setPicking("b")}
                style={{flex:1,padding:"18px 14px",borderRadius:18,background:"#fff",border:"1.5px solid #E5E7EB",display:"flex",flexDirection:"column",alignItems:"center",gap:6,boxShadow:"0 1px 3px rgba(0,0,0,0.04)",transition:"all 0.15s"}}>
                <span style={{fontSize:32,lineHeight:1}}>{langB.flag}</span>
                <span style={{fontSize:14,fontWeight:700,color:"#1a1a2e"}}>{langB.name}</span>
                <span style={{fontSize:10,color:"#9CA3AF",fontWeight:600,letterSpacing:"0.04em"}}>CHANGE</span>
              </button>
            </div>

            <button onClick={handleConnect}
              style={{width:"100%",padding:"16px",borderRadius:14,
                background: service === "ai" ? "linear-gradient(135deg,#6366F1,#8B5CF6)" : "linear-gradient(135deg,#1a1a2e,#374151)",
                color:"#fff",fontSize:16,fontWeight:700,letterSpacing:"-0.01em",
                boxShadow: service === "ai" ? "0 4px 20px rgba(99,102,241,0.35)" : "0 4px 20px rgba(26,26,46,0.25)",
                display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>
              {service === "ai" ? "Start AI Session" : "Connect Now"}
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>
              </svg>
            </button>

            {service !== "ai" && (
              <div style={{fontSize:12,color:"#9CA3AF",textAlign:"center",marginTop:14,lineHeight:1.5}}>
                Typical connect time: under 30 seconds
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  // ─── Step 1: Service Selection (default) ───
  return (
    <div className="im-root" style={{position:"fixed",inset:0,zIndex:9999,background:"rgba(15,16,30,0.6)",backdropFilter:"blur(12px)",display:"flex",alignItems:"center",justifyContent:"center",padding:16,animation:"imFadeIn 0.2s ease"}}>
      <style>{css}</style>
      <div style={{width:"100%",maxWidth:440,background:"#fff",borderRadius:24,overflow:"hidden",boxShadow:"0 24px 64px rgba(0,0,0,0.35)",animation:"imSlideUp 0.3s ease"}}>

        {/* Header */}
        <div style={{padding:"22px 24px 0",display:"flex",alignItems:"flex-start",justifyContent:"space-between"}}>
          <div>
            <div style={{fontSize:22,fontWeight:800,color:"#1a1a2e",letterSpacing:"-0.03em",marginBottom:4}}>Need an interpreter?</div>
            <div style={{fontSize:14,color:"#6B7280"}}>Connect in seconds.</div>
          </div>
          <button onClick={close} style={{width:32,height:32,borderRadius:10,background:"#F3F4F6",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
            <IconClose/>
          </button>
        </div>

        {/* Primary: Human Services */}
        <div style={{padding:"24px 24px 16px",display:"flex",flexDirection:"column",gap:12}}>

          {/* OPI Card */}
          <button className="im-card" onClick={()=>handleServiceSelect("opi")}
            style={{width:"100%",padding:"20px",borderRadius:18,background:"linear-gradient(135deg,#1e40af,#1e3a8a)",color:"#fff",display:"flex",alignItems:"center",gap:16,textAlign:"left",boxShadow:"0 4px 16px rgba(30,64,175,0.25)"}}>
            <div style={{width:52,height:52,borderRadius:16,background:"rgba(255,255,255,0.15)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,backdropFilter:"blur(4px)"}}>
              <IconPhone size={24}/>
            </div>
            <div style={{flex:1}}>
              <div style={{fontSize:17,fontWeight:700,letterSpacing:"-0.01em",marginBottom:2}}>Phone Interpretation</div>
              <div style={{fontSize:12,opacity:0.85,lineHeight:1.4}}>Live audio with a certified interpreter</div>
            </div>
            <IconArrow color="#fff"/>
          </button>

          {/* VRI Card */}
          <button className="im-card" onClick={()=>handleServiceSelect("vri")}
            style={{width:"100%",padding:"20px",borderRadius:18,background:"linear-gradient(135deg,#059669,#047857)",color:"#fff",display:"flex",alignItems:"center",gap:16,textAlign:"left",boxShadow:"0 4px 16px rgba(5,150,105,0.25)"}}>
            <div style={{width:52,height:52,borderRadius:16,background:"rgba(255,255,255,0.15)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,backdropFilter:"blur(4px)"}}>
              <IconVideo size={24}/>
            </div>
            <div style={{flex:1}}>
              <div style={{fontSize:17,fontWeight:700,letterSpacing:"-0.01em",marginBottom:2}}>Video Interpretation</div>
              <div style={{fontSize:12,opacity:0.85,lineHeight:1.4}}>Face-to-face video with a live interpreter</div>
            </div>
            <IconArrow color="#fff"/>
          </button>
        </div>

        {/* Divider */}
        <div style={{padding:"0 24px",display:"flex",alignItems:"center",gap:12}}>
          <div style={{flex:1,height:1,background:"#E5E7EB"}}/>
          <span style={{fontSize:10,fontWeight:700,color:"#9CA3AF",letterSpacing:"0.12em"}}>OR</span>
          <div style={{flex:1,height:1,background:"#E5E7EB"}}/>
        </div>

        {/* Secondary: AI */}
        <div style={{padding:"16px 24px 24px"}}>
          <button className="im-card" onClick={()=>handleServiceSelect("ai")}
            style={{width:"100%",padding:"14px 16px",borderRadius:14,background:"#FAFBFC",border:"1.5px solid #E5E7EB",display:"flex",alignItems:"center",gap:12,textAlign:"left"}}>
            <div style={{width:38,height:38,borderRadius:11,background:"linear-gradient(135deg,#6366F1,#8B5CF6)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              <IconSparkles color="#fff"/>
            </div>
            <div style={{flex:1}}>
              <div style={{display:"flex",alignItems:"center",gap:6}}>
                <span style={{fontSize:14,fontWeight:700,color:"#1a1a2e"}}>AI Interpreter</span>
                <span style={{fontSize:9,fontWeight:800,color:"#8B5CF6",background:"rgba(139,92,246,0.12)",padding:"2px 6px",borderRadius:4,letterSpacing:"0.06em"}}>INSTANT</span>
              </div>
              <div style={{fontSize:11,color:"#6B7280",marginTop:2}}>No wait · Available 24/7</div>
            </div>
            <IconArrow color="#6366F1"/>
          </button>
        </div>

      </div>
    </div>
  );
}
